/** @format */

import AxiosClient from "../AxiosClient";

export const getBanks = (params = {}) => {
  const url = `/api/bank`;
  return AxiosClient.get(url);
};

export const getBranchBanks = (params = {}) => {
  const url = `/api/branch-bank?bankCd=${params.bankCd}`;
  return AxiosClient.get(url);
};

export const getBankAccount = (params) => {
  const url = `/api/bank-account`;
  return AxiosClient.post(url, params);
};
